import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
} from '@mui/material';
import ReportDataService from '../../../services/report.service';
import { useTranslation } from '../../../hooks/useTranslation';

const PaymentsActiveClientsCountsReport = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError('');
        const res = await ReportDataService.getPaymentsActiveClientsCounts();
        setData(res.data?.data || null);
      } catch (e) {
        setError(e.response?.data?.message || t('reports.errorLoading'));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [t]);

  return (
    <Box>
      <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
        {t('reports.paymentsActiveClientsCounts')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('reports.paymentsActiveClientsCountsDescription')}
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          {loading ? (
            <Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>
          ) : (
            <>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('reports.totalActiveClients', { count: data?.total_clients || 0 })} ·{' '}
                {t('reports.totalActiveMemberships', { count: data?.total_active_memberships || 0 })}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          {loading ? null : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{t('payments.client')}</TableCell>
                    <TableCell align="right">{t('reports.activeMemberships')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(data?.clients || []).map((c) => (
                    <TableRow key={c.client_id}>
                      <TableCell>
                        <Typography fontWeight={600}>{c.client_name}</Typography>
                        {c.client_email && (
                          <Typography variant="caption" color="text.secondary" display="block">
                            {c.client_email}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell align="right">{c.active_memberships}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentsActiveClientsCountsReport;

